// extracted by mini-css-extract-plugin
module.exports = {"buttonsContainer":"OnGoingPaymentBox_buttonsContainer__1DZvL","resendInfoText":"OnGoingPaymentBox_resendInfoText__2fEch"};